import { SkeletonText, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const PlaceholderCards: React.FC = () => {
  return (
    <Stack spacing="4">
      <Card p="4">
        <SkeletonText noOfLines={4} spacing="4" />
      </Card>
      <Card p="4">
        <SkeletonText noOfLines={4} spacing="4" />
      </Card>
      <Card p="4">
        <SkeletonText noOfLines={4} spacing="4" />
      </Card>
      <Card p="4">
        <SkeletonText noOfLines={4} spacing="4" />
      </Card>
      <Card p="4">
        <SkeletonText noOfLines={4} spacing="4" />
      </Card>
    </Stack>
  );
};
